import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../stores';
import { bidderChangesLogsFilterPrototypes } from '../../components/filters-menu/filters';
import { ITableFiltersActions, TableFilters } from '@monorepo/base/src/components/table/table-filters/table-filters';

interface IBidderChangesLogsActions {
	currentRoute: string;
}

export function useBidderChangesLogsActions(props: IBidderChangesLogsActions) {
	const { currentRoute } = props;
	const { settingsStore } = useStores<IAdminxStore>();

	const filterStore = settingsStore.getPages().get(currentRoute)?.tableStore.getFiltersStore(currentRoute);
	const currentFilters = filterStore?.getCurrentFilters();

	const DefaultAvailableFilters = [...bidderChangesLogsFilterPrototypes];

	const FiltersActions = (props: ITableFiltersActions) => {
		if (!currentFilters) {
			return null;
		}

		return (
			<TableFilters
				{...props}
				availableFilters={DefaultAvailableFilters}
				currentFilters={currentFilters}
				clearAll={() => filterStore?.clearAll()}
				clearFilter={index => filterStore?.clearFilter(index)}
				addFilter={filter => filterStore?.addFilter(filter)}
				editFilter={(index, filter) => filterStore?.editFilter(index, filter)}
			/>
		);
	};

	return {
		FiltersActions,
	};
}
